var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-btn__content--wrap",attrs:{"data-qa":"wrappedbutton-div-g30ele"}},[_c('v-btn',{staticClass:"text-none white--text py-2 px-4",attrs:{"outlined":"","data-qa":"wrappedbutton-btn-s1eqxb"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }